var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "download",
    transform: "translate(-16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6460",
    "data-name": "Group 6460",
    transform: "translate(18.505)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6459",
    "data-name": "Group 6459"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4887",
    "data-name": "Path 4887",
    d: "M133.954,5.46a.373.373,0,0,0-.341-.219h-1.5V.374A.374.374,0,0,0,131.741,0h-1.5a.374.374,0,0,0-.374.374V5.241h-1.5a.374.374,0,0,0-.281.621l2.62,2.995a.374.374,0,0,0,.563,0l2.62-2.995A.373.373,0,0,0,133.954,5.46Z",
    transform: "translate(-127.998)",
    fill: "#74b1ee"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6462",
    "data-name": "Group 6462",
    transform: "translate(16 8.257)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6461",
    "data-name": "Group 6461"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4888",
    "data-name": "Path 4888",
    d: "M25.533,352v2.246H17.467V352H16v2.995a.741.741,0,0,0,.733.749h9.533a.74.74,0,0,0,.733-.749V352Z",
    transform: "translate(-16 -352)",
    fill: "#74b1ee"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.5ad7ca00c255e68bc3813e2dd36703bb.svg";
export { ForwardRef as ReactComponent };